import { Drawer } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { useCandidatePickDrawer } from '../../hooks/useCandidatePickDrawer';
import type { CandidatePickVacancyMeta } from '../../types';

import { CandidatePickDrawerBody } from './candidate-pick-drawer-body';

type CandidatePickDrawerProps = CandidatePickVacancyMeta & {
  vacancyId: number;
  currency: string;
  paymentPeriod: string;
  opened: boolean;
  onClose: () => void;
};

export const CandidatePickDrawer = ({
  vacancyId,
  vacancyTitle,
  vacantPlaces,
  currency,
  paymentPeriod,
  opened,
  onClose,
}: CandidatePickDrawerProps) => {
  const drawer = useCandidatePickDrawer({
    vacancyId,
    vacancyTitle,
    vacantPlaces,
    currency,
    paymentPeriod,
    opened,
  });
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title='Просмотр кандидатов'
      size={660}
      position='right'
      styles={{
        content: {
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '100dvh',
        },
        body: {
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          justifyContent: 'flex-start',
          overflow: 'hidden',
          padding: isMobile ? 0 : 24,
        },
      }}
      keepMounted={false}
    >
      <CandidatePickDrawerBody
        {...drawer}
        vacancyTitle={vacancyTitle}
        vacantPlaces={vacantPlaces}
      />
    </Drawer>
  );
};
